export default "__VITE_ASSET__e4213e91__"